import * as React from 'react';

const RadioContext = React.createContext(void 0);
function useRadioFieldContext() {
  const state = React.useContext(RadioContext);
  if (!state) {
    throw new Error("useRadioFieldContext must be used within a RadioGroupField");
  }
  return state;
}

export { RadioContext, useRadioFieldContext };
